(function () {
  function updateCountFromYotpo() {
    const bar = document.querySelector(".announcement-bar--static");
    if (!bar) return false;

    const countTarget = bar.querySelector("[data-ab-count]");
    if (!countTarget) return false;

    const yotpoCountEl = document.querySelector("span.reviews-bottomline-total-reviews");
    if (!yotpoCountEl) return false;

    const text = (yotpoCountEl.textContent || "").trim(); // "1438 reviews"
    const digits = text.replace(/\D+/g, "");              // "1438"
    if (!digits) return false;

    countTarget.textContent = digits;
    return true;
  }

  // Probeer direct + luister op late Yotpo inject
  function init() {
    if (updateCountFromYotpo()) return;

    const obs = new MutationObserver(function () {
      if (updateCountFromYotpo()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("load", function () {
      updateCountFromYotpo();
    });
  }

  init();
})();
